/**
 * Central role checks used by admin UIs and admin-only typing-test affordances.
 * Keeps behavior aligned with legacy panels (substring "ADMIN" matches ROLE_SUPER_ADMIN, etc.).
 *
 * @param {{ roles?: string[] } | null | undefined} user
 * @returns {boolean}
 */
export function userHasAdminRole(user) {
  const roles = user?.roles;
  if (!roles?.length) return false;
  return (
    roles.includes("ROLE_ADMIN") ||
    roles.includes("ADMIN") ||
    roles.some((role) => String(role).includes("ADMIN"))
  );
}
